import { isUuid, VENUE_ENQUIRY_TABS, type VenueEnquiryTab } from '@tvitvi/shared';

/** Adressen til husets Datoforespørsler: fanen, og forespørselen som står åpen. */
export interface VenueRequestsSearch {
  tab?: VenueEnquiryTab | undefined;
  enquiry?: string | undefined;
}

export function validateVenueRequestsSearch(search: Record<string, unknown>): VenueRequestsSearch {
  const tab = search['tab'];
  const enquiry = search['enquiry'];
  return {
    ...(typeof tab === 'string' && (VENUE_ENQUIRY_TABS as readonly string[]).includes(tab)
      ? { tab: tab as VenueEnquiryTab }
      : {}),
    ...(typeof enquiry === 'string' && isUuid(enquiry) ? { enquiry } : {}),
  };
}
